import { Outlet } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';

import { PageLayoutProps } from './props';
import { useSmoothInitialRender } from './useSmoothInitialRender';

export function DesktopLayout({ inSecurityFrame }: PageLayoutProps) {
  const { background, opacity } = useSmoothInitialRender(inSecurityFrame);

  return (
    <VStack alignItems="center">
      <VStack
        position="relative"
        background={background}
        opacity={opacity}
        width="100%"
        minHeight={600}
        maxHeight="95vh"
        overflow="auto"
        spacing={3}
      >
        <Outlet />
      </VStack>
    </VStack>
  );
}
